import Component from '../core/Component';

export default class Accord extends Component {

    constructor($element) {
        super($element);
        this.$items = $element.find('[data-accord-item]');
        this.$heads = $element.find('[data-accord-item-head]');
    }

    prepare() {
        var self = this;
        this.$heads
            .on('click', function () {
                //this.$items.removeClass('active');
                $(this).parents('[data-accord-item]').toggleClass('active');
            });
    }
}


// WEBPACK FOOTER //
// ./components/Accord.js